import { Component, JSX } from "react";
import "../../../../App.scss";
import { appContext } from "../../../../AppContext";
import { Navigate } from "react-router-dom";

class Root extends Component
{
    private local = appContext().localStorageProvider;

    private getRedirectTarget(): string
    {
        const token = appContext().authentication.getToken();
        if (!token)
        {
            return "/login";
        }

        const userDetails = this.local.getUserDetails();
        if (userDetails?.userRights)
        {
            return userDetails.userRights.ADMINPORTAL ? "/admin/home" : "/norights";
        }

        return "/login";
    }

    public render(): JSX.Element
    {
        return (
            <Navigate
                to={this.getRedirectTarget()}
                replace
            />
        );
    }
}

export default Root;
